<!-- @format -->

<template>
	<div class="pc-layout">
		<div v-if="$slots.west" ref="west" class="pc-layout_west">
			<slot name="west" />
		</div>
		<div class="pc-layout__body" :style="{ width: width }">
			<slot />
		</div>
		<div v-if="$slots.east" ref="east">
			<slot name="east" />
		</div>
	</div>
</template>
<script>
	export default {
		props: {
			width: {
				type: String,
				default: '',
			},
		},
	};
</script>
<style lang="scss">
	.pc-layout {
		display: flex;

		.pc-layout_west {
			.el-tabs__nav-prev {
				margin: -2px 0 0 0;
			}

			.el-tabs__nav-next {
				margin: -2px 0 0 0;
			}
		}

		.pc-layout__body {
			flex: 1;
			margin: 0;
			overflow: hidden;
		}
	}
</style>
